import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";

import EquipmentForm from "components/equipments/EquipmentForm";
import { createEquipment, updateSpare } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const equipment = {
    name: "",
    location: "",
    description: "",
    companyID: me.companyID ?? "",
    branchID: "",
    deviceID: "",
    routineID: "",
    spares: [],
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        location,
        description,
        companyID,
        branchID,
        deviceID,
        routineID,
        spares,
        coordsLat,
        coordsLng,
      } = valuesParam;

      setLoading(true);

      const equipmentCreated = (
        await API.graphql({
          query: createEquipment.replaceAll("__typename", ""),
          variables: {
            input: {
              name,
              location,
              description,
              companyID,
              branchID,
              deviceID,
              routineID,
              coordsLat,
              coordsLng,
            },
          },
        })
      ).data.createEquipment;

      const promises = [];

      promises.push(
        ...spares?.map((spareId) =>
          API.graphql({
            query: updateSpare.replaceAll("__typename", ""),
            variables: {
              input: {
                id: spareId,
                equipmentID: equipmentCreated.id,
              },
            },
          })
        )
      );

      await Promise.all(promises);

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <EquipmentForm onSubmit={onSubmit} initialValues={equipment} />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Equipo",
    successAdded: "Equipo agregado con éxito",
    responses: {},
  },
});

export default EquipmentCreateForm;
